import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const tagsMarketingInitialValues = {
  name: "",
  color: "#000000",
};

export const tagsMarketingValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type TagsMarketingValues = typeof billInitialValues;

export const billInitialValues = {
  name: "",
  color: "",
  type: "",
  discount: "",
  business_name: "",
  tradename: "",
  tax_identification: "",
  code_postal: "",
  address: "",
  address_number: "",
  address_floor: "",
  location: "",
  city: "",
  province: "",
  responsible: "",
  email: "",
  financial_email: "",
  fees: "",
  fees_course: "",
};

export const billValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  //type: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  type: Yup.string().optional(),
  discount: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  business_name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  tradename: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  tax_identification: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  code_postal: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  address: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  address_number: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  address_floor: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  location: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  city: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  province: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  responsible: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  email: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  financial_email: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  fees: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  fees_course: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type BillValues = typeof billInitialValues;

export const contratosInititalValues = {
  contrato: null,
  clausula: null,
};

export const contratosValidationSchema = Yup.object({
  contract: Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    value ? ["application/pdf"].includes(value.type) : true
  ),
  clauses: Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    value ? ["application/pdf"].includes(value.type) : true
  ),
});

export type ContratosValues = typeof contratosInititalValues;

export const taxInitialValues = {
  tax_id: "",
  iva: "",
  comment_ticket: "",
};

export const taxValidationSchema = Yup.object({
  tax_id: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  iva: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  comment_ticket: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type TaxtIdValues = typeof taxInitialValues;

export const brandInitialValues = {
  profile_avatar: "",
  logo: "",
  firstColor: "",
  secoundColor: "",
};

export const branchValidationSchema = Yup.object({
  logo: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  large_logo: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  firstColor: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  secoundColor: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type BrandValues = typeof brandInitialValues;

/*
export const taxInitialValues = {
  tax_id: "",
  iva: "",
  comment_ticket: "",
};

export const taxValidationSchema = Yup.object({
  tax_id: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  iva: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  comment_ticket: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type TaxtIdValues = typeof taxInitialValues;
*/
